module.exports = __webpack_public_path__ + "img/compartidas.ce914c92.svg";